import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http, Response, Headers, RequestOptions, URLSearchParams } from '@angular/http';
import { DevelopUtil } from '../../utils/develop.utils';

@Injectable()
export class ArrearsHttpService {

  public static ARREARS_URL = DevelopUtil.url('leaseContract/arrears');

  private headers: Headers;
  private requestOptions: RequestOptions;

  constructor(private http: Http) {
    this.headers = new Headers();
    this.requestOptions = new RequestOptions({headers: this.headers});
  }

  getArrears(urlSearchParams: URLSearchParams): Observable<Response> {
    this.requestOptions.search = urlSearchParams;
    return this.http.get(ArrearsHttpService.ARREARS_URL, this.requestOptions);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/arrears/arrears.http.service.ts